import { QueryCache, QueryClient } from '@tanstack/react-query';
import { authAwareRetry } from './mutationRetry';
import { queryCacheOnError } from './queryCacheOnError';

/**
 * The app's TanStack Query client, with its defaults in one place: src/index.tsx builds the app's
 * client with it, and the dev harnesses build theirs with it, so a harness can never drift from
 * the defaults it claims to run under.
 *
 * The onError handler lives in `./queryCacheOnError` so its routing (filter
 * session-expired/MaintenanceError, forward 5xx to maybeProbe('5xx'), forward network-shaped
 * failures to maybeProbe('network-error')) can be unit-tested without booting a client or React.
 * `authAwareRetry` lives in `./mutationRetry` for the same reason, and because the settle steps that
 * reason about a retry having happened (useToggleGoingEvent, useShareQuestionToSpaces) cannot
 * import the app entry point to read the policy they run under.
 */
export const createAppQueryClient = (): QueryClient =>
  new QueryClient({
    queryCache: new QueryCache({
      onError: queryCacheOnError,
    }),
    defaultOptions: {
      queries: {
        retry: authAwareRetry,
        staleTime: 5 * 60 * 1000, // 5 minutes
      },
      mutations: {
        retry: authAwareRetry,
      },
    },
  });
